import { Amplify } from "aws-amplify";

export default function initAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_userPoolId,
        userPoolClientId: process.env.REACT_APP_COGNITO_userPoolWebClientId,
        identityPoolId: process.env.REACT_APP_COGNITO_identityPoolId,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: true,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });
}
